<template>
  <div class="multimedia__content-grid">
    <chat-multimedia-empty
      v-if="isEmpty"
      :tab="$t('multimedia.videos')"
      :campaign="selectedCampaignName"
    />
    <div v-else>
      <div class="multimedia__campaign" v-if="isHistory">
        <span>
          {{ $t("multimedia.tab-from", { tab: $t("multimedia.videos") }) }}
        </span>
        <span class="multimedia__campaign-name"
          >{{ selectedCampaignName }}
        </span>
      </div>
      <div class="grid-x grid-margin-x grid-margin-y">
        <div
          v-for="(video, index) in videosList"
          :key="index"
          class="cell small-12 medium-6 large-4"
        >
          <multimedia-video @selected="selectElement" :video="video" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  components: {
    MultimediaVideo: () => import('@/components/multimedia/items/Video.vue'),
    ChatMultimediaEmpty: () => import('@/components/ChatMultimediaEmpty.vue'),
  },
  props: {
    selectedCampaign: {
      type: [String, null],
    },
    selectedCampaignName: {
      type: [String, null],
    },
  },
  computed: {
    ...mapState(['token']),
    ...mapGetters([
      'activeConversation',
      'activeConversationHistory',
      'dataBankVideos',
    ]),
    conversation() {
      return !this.isHistory
        ? this.activeConversation.conversation
        : this.activeConversationHistory.conversation;
    },
    campaignId() {
      return this.conversation.campaign.id;
    },
    videosList() {
      return this.dataBankVideos({
        campaignId: this.selectedCampaign,
      });
    },
    isEmpty() {
      return this.videosList.length === 0;
    },
  },
  methods: {
    selectElement(video) {
      this.$emit('data-bank-picked', video);
    },
  },
};
</script>
